module.exports = __webpack_public_path__ + "static/logo-32ca3675b5edde93a59250d6d427818c.svg";